import { type FormEvent, useState } from "react";

import { Button, Field, Input, Label } from "@web-app/components";
import type { CreateDashboardPayload } from "@web-app/types";

export function CreateDashboard({
  onClose,
  onCreateDashboard,
}: {
  onClose: () => void;
  onCreateDashboard: (payload: CreateDashboardPayload) => void;
}) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const payload: CreateDashboardPayload = {
      description,
      title,
    };

    onCreateDashboard(payload);
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto p-1">
        <form
          id="create-dashboard-form"
          onSubmit={onSubmit}
          className="space-y-6"
        >
          <Field>
            <Label required>Title</Label>
            <Input
              type="text"
              name="title"
              value={title}
              required
              placeholder="e.g., Revenue Overview"
              onChange={(value) => setTitle(value)}
            />
          </Field>
          <Field>
            <Label>Description</Label>
            <Input
              type="text"
              name="description"
              value={description}
              placeholder="e.g., Track daily, weekly and monthly revenue trends"
              onChange={(value) => setDescription(value)}
            />
          </Field>
        </form>
      </div>
      <div className="absolute bottom-0 left-0 w-full border-t border-gray-200 p-4">
        <div className="flex gap-3">
          <Button type="submit" form="create-dashboard-form">
            Create
          </Button>
          <Button type="button" plain onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
}
